module.exports = __webpack_public_path__ + "img/ic-announcement-active.5b87b023.svg";